import {
  all,
  append,
  equals,
  gt,
  gte,
  head,
  map,
  min,
  pipe,
  reduce,
} from "ramda";

function allMinimumsMet(item) {
  // DB does not currently prevent setting minimums that are higher
  // than the number of options available, so we need to check for the
  // min of the two values.
  /** @type {{sides: unknown[], minSides: number, selectedSides: unknown[], selectedModifiers: Array<{id: string | number, mods: unknown[], safeMin: number}>}} */
  const typedItem = item;
  const safeMinSides = min(typedItem.sides.length, typedItem.minSides);

  return all(equals(true))(
    append(
      gte(typedItem.selectedSides.length, safeMinSides), // Sides meet minimum requirement
      map(
        group => gte(group.mods.length, group.safeMin),
        typedItem.selectedModifiers
      )
    )
  );
}

function scrollToMissingRequirements(scrollElement) {
  const nodesMissingRequired = scrollElement.getElementsByClassName("required");

  // HTMLCollection is not an array so isEmpty will not work here.
  if (nodesMissingRequired && gt(nodesMissingRequired.length, 0)) {
    /** @type {HTMLElement[]} */
    const missingNodes = Array.from(nodesMissingRequired);
    const firstMissingNode = head(missingNodes);
    if (firstMissingNode) {
      const firstChild = /** @type {HTMLElement} */ (
        scrollElement.childNodes[0]
      );
      scrollElement.scrollTop =
        firstMissingNode.offsetTop - firstChild.offsetTop;
    }
  }
}

function getMaxAllowedQty(item) {
  /** @type {import("true-myth").Maybe<number>[]} */
  const selectedSideStockLevels =
    /** @type {import("true-myth").Maybe<number>[]} */ (
      map(side => side.stockLevel, item.selectedSides)
    );
  const stockLevels = [item.stockLevel].concat(selectedSideStockLevels);
  /** @type {(stockLevel: import("true-myth").Maybe<number>) => number} */
  const getStockLevel = stockLevel =>
    stockLevel.match({ Just: value => value, Nothing: () => Infinity });
  return /** @type {number} */ (
    pipe(map(getStockLevel), reduce(min, Infinity))(stockLevels)
  );
}

export { allMinimumsMet, scrollToMissingRequirements, getMaxAllowedQty };
